import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Inline, Container, Subnav, ListItem } from 'chaoskit/src/components'
import { tealDarkBlue } from 'chaoskit/src/assets/styles/utility/gradient'
import { SubnavMenuItemStyles } from 'chaoskit/src/components/Subnav'

import BaseLayout from './BaseLayout'

import Hero, { HeroContent, HeroTitleWrapper, HeroTitle } from '~partials/Hero'
import Link from '~components/Link'
import Particles from '~components/Particles'

const SecurityLayout = ({ title, children }) => {
  const theme = useTheme()

  return (
    <BaseLayout>
      <Hero compact css={[tealDarkBlue(theme)]}>
        <Particles />
        <HeroContent>
          <Container>
            <HeroTitleWrapper>
              <HeroTitle size="large">{title}</HeroTitle>
            </HeroTitleWrapper>
          </Container>
        </HeroContent>
      </Hero>
      <Subnav>
        <div>
          <Inline wrap={false} size="large">
            <ListItem>
              <Link css={SubnavMenuItemStyles(theme)} exact to="/security/">
                Overview
              </Link>
            </ListItem>
            <ListItem>
              <Link css={SubnavMenuItemStyles(theme)} to="/security/practices/">
                Practices
              </Link>
            </ListItem>
            <ListItem>
              <Link
                css={SubnavMenuItemStyles(theme)}
                to="/docs/security/overview/"
              >
                Docs
              </Link>
            </ListItem>
          </Inline>
        </div>
      </Subnav>
      {children}
    </BaseLayout>
  )
}

SecurityLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
}

export default SecurityLayout
